import { Children, isValidElement } from 'react';
import hasChildren from './hasChildren.js';

var hasComplexChildren = function hasComplexChildren(element) {
  return isValidElement(element) && hasChildren(element) && Children.toArray(element.props.children).reduce(function (response, child) {
    return response || isValidElement(child);
  }, false);
};

export default hasComplexChildren;